import React from 'react';
import { css } from '@linaria/core';
import { theme } from '@terveystalo/design-system-theme';
import { Text } from '../../atoms/Typography';
import { classnames } from '../../utils';
/**
 * Description element to be used in form fields between the label and the input.
 */
export const FormFieldDescription = ({ children, as, className }) => {
    return (React.createElement(Text, { as: as, size: "m", className: classnames(css `
          display: flex;
          margin-bottom: ${theme.spacing['1']};
        `, className) }, children));
};


import "../../../css/molecules/FormFieldDescription/FormFieldDescription.css";
